/**
 * Reload page when the user go back with the arrow of the browser
 * @see https://gradiweb.monday.com/boards/2277379901/pulses/2972635962
 * @autor Michael Ballen
 */
export const reloadPage = () => {
  const perfEntries = performance.getEntriesByType('navigation');

  if (perfEntries.length) {
    if (perfEntries[0].type === 'back_forward') {
      location.reload(true);
    }
  }
};
